<ng-container>
	<div *ngIf="!serviceDateExpired()" class="screen-element dashboard-idle">
		<div class="left-side">
			<div class="idle-iconbar">
				<iconbar [classes]="'idle'"></iconbar>
			</div>
			<div class="idle-dashboard-center">
				<div class="value">{{vorlaufTemp.toString({include_unit:false})}}</div>
				<div class="unit">{{vorlaufTemp.getUnit()}}</div>
			</div>
			<div class="text text-1">{{getTranslator().tr("DELIGHT_IDLE_INFO_MESSAGE_TEMPERATURE_1")}}</div>
			<div class="text text-2">{{getTranslator().tr("DELIGHT_IDLE_INFO_MESSAGE_TEMPERATURE_2")}}</div>
		</div>
		<div class="right-side">
			<div class="value value-1">{{getIoService().getCurrentTime()| date: "HH:mm"}}</div>
			<div class="text text-1">{{getTranslator().tr("AICI_TIME")}}</div>

			<div *ngIf="hasOutdoorTempSensor" class="value value-1">{{outdoorTempSensor.toString()}}</div>
			<div *ngIf="hasOutdoorTempSensor" class="text text-1">
				{{
				getTranslator().tr("AICI_OUTSIDE")
				}}
			</div>

			<div *ngIf="hasHeating()" class="value value-1">{{getHeatingValue()}}</div>
			<div *ngIf="hasHeating()" class="text text-1">{{getTranslator().tr("DELIGHT_IDLE_CH_DEMAND")}}</div>

			<div *ngIf="hasDHW()" class="value value-1">{{getDHWValue()}}</div>
			<div *ngIf="hasDHW()" class="text text-1">{{getTranslator().tr("DELIGHT_IDLE_DHW_DEMAND")}}</div>

			<div *ngIf="pressureSensor" class="value value-1">{{pressureSensor.toString()}}</div>
			<div *ngIf="pressureSensor" class="text text-1">
				{{
				getTranslator().tr(
				"DELIGHT_IDLE_INFO_MESSAGE_PRESSURE_LEFT"
				)
				}}
			</div>


		</div>
	</div>
	<div *ngIf="serviceDateExpired()" class="screen-element dashboard-service">
		<div class="screen-element toast-screen">
			<div class="dashboard-center">
				<div class="icon iconCompetentPersonInstaller"></div>
			</div>
			<div class="text text-1"><text-widget [color]="'white'"
					[text]="getTranslator().tr('OTX_MAINTENANCE_3_1')"></text-widget></div>
			<div class="text text-2"><text-widget [color]="'white'"
					[text]="getTranslator().tr('OTX_MAINTENANCE_3_2')"></text-widget></div>
			<div class="text text-3"><text-widget [color]="'white'" [text]="serviceCompany"></text-widget></div>
			<div class="text text-4"><text-widget [color]="'white'" [text]="servicePhoneNumber"></text-widget></div>

		</div>
	</div>
</ng-container>